import { trackCardElement, trackSponsorElement } from '@services/GoogleTagManagerService';
import { findSponsorsByName } from '@shared/RandomSponsors/utils';
import { getSponsorDataFromService } from '@utilities/sponsor';

export type PkCardSponsorPluginOptions = {
  mainSponsor: {
    type: string;
    name: string;
  };
};
export default class PkCardSponsorPlugin {
  options: PkCardSponsorPluginOptions;
  dom: HTMLElement;
  sponsorName: string;
  card: HTMLPkCardElement;

  constructor(dom: HTMLElement, o: PkCardSponsorPluginOptions) {
    const defaults = {};

    this.options = {
      ...defaults,
      ...o,
    };

    this.dom = dom;
    this.card = dom.querySelector<HTMLPkCardElement>('.js-pk-card-sponsor');

    this.sponsorName = this.options?.mainSponsor?.type;
  }

  async init() {
    if (!this.sponsorName) return;

    const results = await getSponsorDataFromService(window.competitionId);
    const sponsor = findSponsorsByName(results, this.sponsorName);
    if (!sponsor) return;

    if (this.dom.dataset.tracking) {
      const cardTracking = JSON.parse(this.dom.dataset.tracking) as any;
      cardTracking.name = `${sponsor.code} - ${cardTracking.name}`;
      cardTracking['item_category3'] = 'sponsored';
      cardTracking['item_category4'] = sponsor.code;

      trackCardElement(cardTracking)(this.dom);
    }

    if (!this.card) return;
    const position = location.href.includes('/news/') ? 'card_news' : 'card_homepage';
    const trackingData = {
      id: `${sponsor.code}-branded-card-${position}`,
      name: sponsor.code,
      creative: 'branded-card',
      position,
    };

    this.card.sponsor = true;
    this.card.sponsorImage = sponsor.image;
    this.card.sponsorPosition = 'top-left';
    trackSponsorElement(trackingData, true)(this.card);

    sponsor.colour && this.card.style.setProperty('--pk-sponsor-strip--color', sponsor.colour);
    this.card.sponsorStripColor = 'sponsor-strip--color';
  }
}
